export const nullish = (a, b) => a !== null && a !== undefined ? a : b;
export const increase = (val) => Math.floor(Number(val)) + 1;
export const decrease = (val) => Math.floor(Number(val)) - 1;
export const styleWidth = (val) => {
    return { width: `${val.length}ch` };
};
export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
export const inputChange = (e, setState, min, max, callback) => {
    const target = e.target;
    if (isNaN(Number(target.value)))
        return;
    const numVal = clamp(Number(target.value), min, max);
    if (target.value && target.value !== String(numVal))
        target.value = String(numVal); // Added for preact
    setState(numVal);
    if (!target.value)
        setState('');
    if (callback)
        callback(Number(target.value));
};
export const beforeInputChange = (e) => {
    const event = e;
    if (!(!event.data || /^\d+$/.test(event.data)))
        e.preventDefault();
};
export const clickIncreaseDecrease = (setState, num, min, max, callback) => {
    setState(clamp(num, min, max));
    if (callback)
        callback(num);
};
export const onKeyDownEvent = (e, num, min, max, setInputValue, setReadOnly, setAddClassPlus, setAddClassMinus, increasedValue, decreasedValue, onIncrease, onDecrease, onKeyDown) => {
    const ArrowUp = 'ArrowUp';
    const ArrowDown = 'ArrowDown';
    if (e.key === ArrowUp) {
        e.preventDefault();
        if (Number(num) < max) {
            setReadOnly(true);
            setInputValue(increasedValue);
            setAddClassPlus(true);
            if (onIncrease)
                onIncrease(increasedValue);
        }
        else {
            setAddClassPlus(false);
            setReadOnly(true);
        }
    }
    if (e.key === ArrowDown) {
        e.preventDefault();
        if (num === 0 || num === '' || Number(num) <= min) {
            setInputValue(min);
            setAddClassMinus(false);
        }
        else if (Number(num) > min) {
            setReadOnly(true);
            setInputValue(decreasedValue);
            setAddClassMinus(true);
            if (onDecrease)
                onDecrease(decreasedValue);
        }
    }
    if (onKeyDown)
        onKeyDown(e);
};
export const onKeyUpEvent = (e, setReadOnly, setAddClassPlus, setAddClassMinus, onKeyUp) => {
    setReadOnly(false);
    if (e.key === 'ArrowUp') {
        setAddClassPlus(false);
    }
    else if (e.key === 'ArrowDown') {
        setAddClassMinus(false);
    }
    if (onKeyUp)
        onKeyUp(e);
};
export const inputValueChange = (val, setAriaValue, callback) => {
    if (callback)
        callback(Number(val));
    setAriaValue(val);
    const timeoutID = setTimeout(() => setAriaValue(null), 3000);
    return () => clearTimeout(timeoutID);
};
export const onBlurEvent = (num, min, setState, callback) => {
    if (Number(num) < min || num === '') {
        setState(min);
    }
    if (callback)
        callback(Number(num));
};
